<template>
    <div class="row gutters mt-1">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex overflow-auto" style="gap: 10px">
            <router-link to="/cliente" class="flex-grow-1">
                <div class="info-stats4" @click="$router.push('/cliente')" style="cursor: pointer">
                    <div class="info-icon">
                        <i class="icon-users"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ peoples.total }}</h3>
                        <p>{{ this.t('DASHBOARD.PEOPLES') }}</p>
                    </div>
                </div>
            </router-link>
            <router-link :to="hasAllotments ? '/reserva' : '/'" class="flex-grow-1">
                <div class="info-stats4" @click="$router.push('')" style="cursor: pointer">
                    <div class="info-icon">
                        <i class="icon-lock-open"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ reservesActive.total }}</h3>
                        <p>{{ this.t('RESERVE.INDEX_TITLE') }}</p>
                    </div>
                </div>
            </router-link>
            <div class="flex-grow-1">
                <div class="info-stats4" @click="loadReservesExpire" data-toggle="modal" data-target="#reservesExpiringModal" style="cursor: pointer">
                    <div class="info-icon">
                        <i class="icon-timer"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ reservesExpiring?.total || 0 }}</h3>
                        <p>{{ this.t('DASHBOARD.RESERVES_EXPIRING') }}</p>
                    </div>
                </div>
            </div>
            <router-link to="/loteamento" class="flex-grow-1">
                <div class="info-stats4">
                    <div class="info-icon">
                        <i class="icon-grid"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ allotments.total }}</h3>
                        <p>{{ this.t('ALLOTMENT.INDEX_TITLE') }}</p>
                    </div>
                </div>
            </router-link>
            <router-link to="/lote" class="flex-grow-1">
                <div class="info-stats4">
                    <div class="info-icon">
                        <i class="icon-map-pin"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ lots.total }}</h3>
                        <p>{{ this.t('LOTS.INDEX_TITLE') }}</p>
                    </div>
                </div>
            </router-link>
            <router-link to="/" class="flex-grow-1"
                         v-if="validatePermissions('ConfigClickSign:index') && hasConfigClickSign">
                <div class="info-stats4" @click="openClickSign"
                     style="cursor: pointer">
                    <div class="info-icon">
                        <i class="icon-border_color"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ clicksign_documents?.total }}</h3>
                        <p>{{ this.t('ASSIGN.ASSIGNS') }}</p>
                    </div>
                </div>
            </router-link>
            <router-link to="/documentos" class="flex-grow-1" style="min-width: max-content">
                <div class="info-stats4" @click="$router.push('')" style="cursor: pointer">
                    <div class="info-icon">
                        <i class="icon-cloud_upload"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ this.formatSize(drive.total) }} /
                            {{ drive.maxStore ? formatMaxStore(drive.maxStore) : '0.00' }}
                            {{ getExtensionSize(drive.maxStore) }} </h3>
                        <p>{{ this.t('DASHBOARD.TOTAL_STORED_AVAILABLE') }}</p>
                        <div class="storage-progress"
                             :class="{'storage-progress--warning': storagePercent() >= 90}">
                            <span class="storage-progress__fill"
                                  :style="{width: storagePercent() + '%'}"></span>
                        </div>
                    </div>
                </div>
            </router-link>
        </div>
        <modal id-modal="reservesExpiringModal" :title-modal="t('DASHBOARD.RESERVES_EXPIRING')" modal-large>
            <template v-slot:title>{{ t('DASHBOARD.RESERVES_EXPIRING') }}</template>
            <div class="modal-body reserves-expiring-modal">
                <div class="reserves-expiring-modal__header">
                    <div>
                        <span class="reserves-expiring-modal__eyebrow">{{ t('DASHBOARD.RESERVES_EXPIRING') }}</span>
                        <h5>{{ t('DASHBOARD.RESERVES_EXPIRING_MODAL_TITLE') }}</h5>
                    </div>
                    <span class="reserves-expiring-modal__header-icon"><i class="icon-alarm_on"></i></span>
                </div>

                <div class="reserves-expiring-modal__summary">
                    <div class="reserves-expiring-modal__metric reserves-expiring-modal__metric--warning">
                        <span class="reserves-expiring-modal__summary-icon">
                            <i class="icon-timer"></i>
                        </span>
                        <div>
                            <small>Próximas de Expirar</small>
                            <h4 class="mb-1">{{ totalReservesExpiring }}</h4>
                            <p class="mb-0">{{ t('DASHBOARD.RESERVES_EXPIRING_MODAL_TEXT') }}</p>
                        </div>
                    </div>
                    <div class="reserves-expiring-modal__metric reserves-expiring-modal__metric--active">
                        <span class="reserves-expiring-modal__summary-icon">
                            <i class="icon-lock-open"></i>
                        </span>
                        <div>
                            <small>{{ t('DASHBOARD.RESERVES_TOTAL') }}</small>
                            <h4 class="mb-1">{{ reservesActive?.total || 0 }}</h4>
                            <p class="mb-0">{{ t('DASHBOARD.RESERVES_TOTAL_MODAL_TEXT') }}</p>
                        </div>
                    </div>
                </div>

                <div v-if="reservesExpiringList.length" class="reserves-expiring-list">
                    <div class="reserves-expiring-list__item" v-for="allotment in reservesExpiringList"
                         :key="allotment.allotment_id" @click="openReservesExpiringByAllotment(allotment)">
                        <div class="reserves-expiring-list__info">
                            <span class="reserves-expiring-list__icon"><i class="icon-grid"></i></span>
                            <div>
                                <strong>{{ allotment.allotment_name }}</strong>
                                <small>{{ t('DASHBOARD.RESERVES_EXPIRING_VIEW_DETAILS') }}</small>
                            </div>
                        </div>
                        <div class="reserves-expiring-list__action">
                            <div class="reserves-expiring-list__total">
                                <strong>{{ allotment.total }}</strong>
                                <span>{{ t('DASHBOARD.RESERVES_EXPIRING_TOTAL_LABEL') }}</span>
                            </div>
                            <i class="icon-chevron-right reserves-expiring-list__arrow"></i>
                        </div>
                    </div>
                </div>

                <div v-else class="reserves-expiring-empty">
                    <i class="icon-info_outline"></i>
                    <p class="mb-0">{{ t('DASHBOARD.RESERVES_EXPIRING_NOT_FOUND') }}</p>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import permission from '../../../components/permission';
import ConfigClickSign from '../../../services/ConfigClickSign';
import {mapState} from 'vuex';
import Modal from '@/components/modal';
import Reserves from '../../../services/Reserves';

export default {
    name: "cardsGeralRedirectionsComponent",
    components: {Modal},
    props: ['peoples', 'reservesActive', 'reservesExpiring', 'allotments', 'lots', 'clicksign_documents','drive'],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            reservesExpireByAllotment: {},
        }
    },
    computed:{
        ...mapState({
            hasConfigClickSign: 'hasConfigClickSign',
            hasAllotments: 'hasAllotments',
        }),
        reservesExpiringList() {
            return Object.values(this.reservesExpireByAllotment || {}).sort((first, second) => {
                return first.allotment_name.localeCompare(second.allotment_name);
            });
        },
        totalReservesExpiring() {
            return this.reservesExpiring?.total || this.reservesExpiringList.reduce((total, allotment) => {
                return total + Number(allotment.total || 0);
            }, 0);
        },
    },
    mixins: [permission],
    methods:{
        loadReservesExpire(){
            this.$store.commit('changeLoading', true);
            Reserves.getResumREservesNextExpire().then(resp => {
                this.reservesExpireByAllotment = resp.data || {};
            }).catch(() => {
                this.reservesExpireByAllotment = {};
            }).finally(() => this.$store.commit('changeLoading', false))
        },
        openReservesExpiringByAllotment(allotment) {
            this.$store.commit('changeLoading', true);
            document.getElementById('closeX')?.click();
            sessionStorage.setItem('allotmentIdScope', allotment.allotment_id);
            this.$router.push({name: 'IndexReserve'});
        },
        storagePercent() {
            if (!this.drive.maxStore || !this.drive.total) return 0;
            const availableBytes = this.drive.maxStore * 1000000000;
            return Math.min(100, Math.round((this.drive.total / (this.drive.total + availableBytes)) * 100));
        },
        openClickSign(){
            this.$store.commit('changeLoading', true);
            ConfigClickSign.getRedirectAssign().then(resp => {
                window.open(`${process.env.VUE_APP_CLICK_SIGN_FRONT_HOST}/loginDisponibilidade/${resp.data}`,'blank');
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.$store.commit('changeLoading', false);
            })
        },
        formatSize(fileSize) {
            if (!fileSize) return '0.0';
            if (fileSize < 1000) return `${fileSize} Bytes`;
            if (fileSize > 1000 && fileSize < 1000000) return `${(fileSize / 1000).toFixed()} KB`;
            if (fileSize >= 1000000 && fileSize < 1000000000) return `${(fileSize / 1000000).toFixed(2)} MB`;
            if (fileSize >= 1000000000) return `${(fileSize / 1000000000).toFixed(2)} GB`;
        },
        formatMaxStore(value) {
            if (value < 1) {
                return (value * 1000).toFixed(1);
            }
            return value
        },
        getExtensionSize(size) {
            if (size < 1) {
                return 'MB';
            } else return 'GB';
        },
    }
}
</script>

<style scoped>
.storage-progress {
    background: #e6edf2;
    border-radius: 999px;
    height: 5px;
    margin-top: 0.45rem;
    min-width: 130px;
    overflow: hidden;
    width: 100%;
}

.storage-progress__fill {
    background: linear-gradient(90deg, #0e5e4e, #14b8a6);
    border-radius: 999px;
    display: block;
    height: 100%;
    transition: width 0.4s ease;
}

.storage-progress--warning .storage-progress__fill {
    background: linear-gradient(90deg, #d97706, #f59e0b);
}

html.dark-theme .storage-progress {
    background: rgba(148, 163, 184, 0.16) !important;
}

.reserves-expiring-modal {
    background: #f8fafc;
    padding: 22px !important;
    padding-top: 24px !important;
}

.reserves-expiring-modal__header {
    align-items: center;
    background: linear-gradient(135deg, #fff7ed, #ffffff 62%);
    border: 1px solid #fed7aa;
    border-radius: 16px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    padding: 18px 20px;
}

.reserves-expiring-modal__header h5 {
    color: #1f2937;
    font-size: 18px;
    font-weight: 700;
    margin: 0;
}

.reserves-expiring-modal__eyebrow {
    color: #d97706;
    display: block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin-bottom: 6px;
    text-transform: uppercase;
}

.reserves-expiring-modal__header-icon {
    align-items: center;
    background: #ffffff;
    border: 1px solid rgba(217, 119, 6, 0.18);
    border-radius: 14px;
    box-shadow: 0 12px 22px rgba(217, 119, 6, 0.12);
    color: #d97706;
    display: inline-flex;
    flex-shrink: 0;
    font-size: 24px;
    height: 50px;
    justify-content: center;
    width: 50px;
}

.reserves-expiring-modal__summary {
    display: flex;
    gap: 14px;
    margin-bottom: 18px;
}

.reserves-expiring-modal__metric {
    align-items: center;
    background: #ffffff;
    border: 1px solid #e6edf2;
    border-radius: 16px;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
    display: flex;
    flex: 1;
    gap: 14px;
    padding: 16px;
}

.reserves-expiring-modal__summary h4 {
    color: #1f2937;
    font-size: 30px;
    font-weight: 700;
    line-height: 1;
}

.reserves-expiring-modal__summary p {
    color: #64748b;
}

.reserves-expiring-modal__summary small {
    color: #d97706;
    display: block;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    margin-bottom: 6px;
    text-transform: uppercase;
}

.reserves-expiring-modal__summary-icon,
.reserves-expiring-list__icon {
    align-items: center;
    background: rgba(217, 119, 6, 0.12);
    border-radius: 999px;
    color: #d97706;
    display: inline-flex;
    flex-shrink: 0;
    height: 42px;
    justify-content: center;
    width: 42px;
}

.reserves-expiring-modal__metric--active .reserves-expiring-modal__summary-icon {
    background: rgba(14, 94, 78, 0.12);
    color: #0e5e4e;
}

.reserves-expiring-modal__metric--active small {
    color: #0e5e4e;
}

.reserves-expiring-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.reserves-expiring-list__item {
    align-items: center;
    background: #ffffff;
    border: 1px solid #e6edf2;
    border-radius: 16px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    padding: 16px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.reserves-expiring-list__item:hover {
    border-color: rgba(217, 119, 6, 0.38);
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
    transform: translateY(-1px);
}

.reserves-expiring-list__info {
    align-items: center;
    display: flex;
    gap: 12px;
}

.reserves-expiring-list__info strong {
    color: #1f2937;
    display: block;
    font-size: 15px;
}

.reserves-expiring-list__info small {
    color: #64748b;
}

.reserves-expiring-list__total {
    background: rgba(217, 119, 6, 0.12);
    border-radius: 10px;
    color: #92400e;
    min-width: 86px;
    padding: 8px 12px;
    text-align: center;
}

.reserves-expiring-list__total strong {
    display: block;
    font-size: 22px;
    line-height: 1;
}

.reserves-expiring-list__total span {
    font-size: 12px;
}

.reserves-expiring-list__action {
    align-items: center;
    display: flex;
    gap: 12px;
}

.reserves-expiring-list__arrow {
    color: #94a3b8;
    font-size: 20px;
    transition: color 0.2s ease, transform 0.2s ease;
}

.reserves-expiring-list__item:hover .reserves-expiring-list__arrow {
    color: #d97706;
    transform: translateX(3px);
}

.reserves-expiring-empty {
    align-items: center;
    background: #ffffff;
    border: 1px dashed #cbd5e1;
    border-radius: 16px;
    color: #64748b;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 28px 16px;
    text-align: center;
}

.reserves-expiring-empty i {
    font-size: 28px;
}

html.dark-theme .reserves-expiring-modal,
html.dark-theme .reserves-expiring-modal__metric,
html.dark-theme .reserves-expiring-modal__header,
html.dark-theme .reserves-expiring-list__item,
html.dark-theme .reserves-expiring-empty {
    background: #1f2937 !important;
    border-color: rgba(148, 163, 184, 0.18) !important;
}

html.dark-theme .reserves-expiring-modal__summary h4,
html.dark-theme .reserves-expiring-modal__header h5,
html.dark-theme .reserves-expiring-list__info strong {
    color: #f8fafc;
}

html.dark-theme .reserves-expiring-modal__summary p,
html.dark-theme .reserves-expiring-list__info small,
html.dark-theme .reserves-expiring-empty {
    color: #cbd5e1;
}

html.dark-theme .reserves-expiring-modal__summary small {
    color: #f59e0b;
}

html.dark-theme .reserves-expiring-modal__metric--active small {
    color: #14b8a6;
}

html.dark-theme .reserves-expiring-modal__header-icon {
    background: rgba(217, 119, 6, 0.12);
    border-color: rgba(217, 119, 6, 0.24);
}

@media (max-width: 575px) {
    .reserves-expiring-modal {
        padding: 16px !important;
        padding-top: 18px !important;
    }

    .reserves-expiring-modal__header {
        align-items: flex-start;
        gap: 14px;
    }

    .reserves-expiring-modal__summary {
        flex-direction: column;
    }

    .reserves-expiring-list__item {
        align-items: flex-start;
        flex-direction: column;
        gap: 12px;
    }

    .reserves-expiring-list__total {
        width: 100%;
    }

    .reserves-expiring-list__action {
        width: 100%;
    }
}
</style>
